/**
 * shopManagementService - 店舗・レジ情報管理API
 *
 * GET /api/shopmanagement     全店舗・レジ一覧取得
 * POST /api/shopmanagement    新規店舗追加
 * PUT /api/shopmanagement/:shopNo  店舗・レジ更新
 * DELETE /api/shopmanagement/shop/:shopNo  店舗を非アクティブ化
 * DELETE /api/shopmanagement/regi/:shopNo/:regiNo  レジを非アクティブ化
 */

const handleResponse = async (res) => {
  if (!res.ok) {
    const json = await res.json().catch(() => ({}));
    const err = new Error(json.error || `リクエスト失敗: ${res.status}`);
    // 409 UserID重複エラー: conflictUserIds をエラーオブジェクトに付与してフロント側で参照できるようにする
    if (json.conflictUserIds) err.conflictUserIds = json.conflictUserIds;
    throw err;
  }
  return res.json();
};

export async function fetchShopManagement() {
  const res = await fetch('/api/shopmanagement');
  const data = await handleResponse(res);
  return data.data;
}

export async function createShop(payload) {
  const res = await fetch('/api/shopmanagement', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function updateShop(shopNo, payload) {
  const res = await fetch(`/api/shopmanagement/${shopNo}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function deactivateShop(shopNo) {
  const res = await fetch(`/api/shopmanagement/shop/${shopNo}`, {
    method: 'DELETE',
  });
  return handleResponse(res);
}

export async function deactivateRegi(shopNo, regiNo) {
  const res = await fetch(`/api/shopmanagement/regi/${shopNo}/${regiNo}`, {
    method: 'DELETE',
  });
  return handleResponse(res);
}

